module.exports = __webpack_public_path__ + "static/media/YM03_5.d14bbf23.jpg";